import axios from 'axios';
import qs from 'qs'
const downLoadReq = (method, url, params, upload) => {
	let data = method.toLocaleLowerCase() === 'get' ? 'params' : 'data';
	let contentType = 'application/x-www-form-urlencoded'
	if(upload){
		contentType = 'multipart/form-data;charset=UTF-8'
	}
	return axios({
		method: method,
		url: url,
		
		headers: {
			'Content-Type': contentType,
			 token:sessionStorage.getItem("token") || ''
		},
		[data]: params,
		paramsSerializer:params => {
			return qs.stringify(params)
			
		},
		traditional: true,
		responseType: 'blob',
		transformRequest: [
			function(data) {
				if( !upload){
					let ret = ''
					for (let it in data) {
						ret +=
							encodeURIComponent(it) +
							'=' +
							encodeURIComponent(data[it]) +
							'&'
					}
					return ret
				}else{
					return data
				}
				
			}
		]
	}).then(res => {

		if(res.errCode) {
			if(res.errCode >= 500){
				return {...res,msg:'服务器请求错误，请稍后再尝试'}
			}
		}
		return res.data
	});
};
const downLoadPostReq = (url, params) => {

	return axios({
	  method: 'post',
	  url: url,
	  data:params,
	  headers: {
		'Content-Type': 'application/json;chartset=UTF-8',
		token: sessionStorage.getItem("token") || ''
	  },
  
	  traditional: true,
	  responseType: 'blob',
  
	}).then(res => {
	  console.log(res)
	  if (res.errCode) {
		if (res.errCode >= 500) {
		  return { ...res,
			msg: '服务器请求错误，请稍后再尝试'
		  }
		}
	  }
	  return res.data
	});
  
  
  };

export {
	downLoadReq,
	downLoadPostReq
}


// WEBPACK FOOTER //
// ./src/api/downLoad.js